import React from 'react'
import Patient_amount_view from './child/Patient_amount_view'
import PatientDetails from './child/PatientDetails'




const DashBoardLayerSeven = () => {
    return (
        <>
            <div className="row gy-4">
                <div className="col-lg-4 ">
                    <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
                        <img
                            src="assets/images/nft/nft-gradient-bg.png"
                            alt=""
                            className="w-100 object-fit-cover"
                        />
                        <div className=" ms-16 mb-24 me-16  mt--100">
                            <div className="text-center">
                                <img
                                    src="assets/images/dummy_user.jpg"
                                    alt=""
                                    className="border br-white border-width-2-px w-200-px h-200-px rounded-circle object-fit-cover"
                                />
                                <h6 className="mb-0 mt-16">Jacob Jones</h6>
                                <p className="text-secondary-light mb-1">OP-10039</p>
                                <p className="text-secondary-light mb-1">7580061064</p>
                                <p className="text-secondary-light mb-1">ifrandom@gmail.com</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-lg-4 bg-white rounded-4'>
                    <PatientDetails />
                </div>
                <div className='col-lg-4'>
                    <Patient_amount_view />
                </div>
            </div>

        </>
    )
}

export default DashBoardLayerSeven